import { useEffect, useRef, useState } from 'react';

interface UseDelayedFlagParams {
  value: boolean;
  delayMs: number;
  minHoldMs?: number;
}

const useDelayedFlag = ({ value, delayMs, minHoldMs = 0 }: UseDelayedFlagParams) => {
  const [isOn, setIsOn] = useState(false);
  const isOnRef = useRef(false);
  const shownAtRef = useRef(0);

  useEffect(() => {
    const turnOn = () => {
      isOnRef.current = true;
      shownAtRef.current = Date.now();
      setIsOn(true);
    };

    const turnOff = () => {
      isOnRef.current = false;
      setIsOn(false);
    };

    if (value) {
      if (isOnRef.current) {
        return undefined;
      }
      const timer = setTimeout(turnOn, delayMs);
      return () => clearTimeout(timer);
    }

    if (!isOnRef.current) {
      return undefined;
    }

    const remaining = Math.max(0, minHoldMs - (Date.now() - shownAtRef.current));
    if (remaining === 0) {
      turnOff();
      return undefined;
    }

    const timer = setTimeout(turnOff, remaining);
    return () => clearTimeout(timer);
  }, [value, delayMs, minHoldMs]);

  return isOn;
};

export default useDelayedFlag;
